<template>
  <div class="top-bar">
    <div class="row" style="background: white; padding-top: 15px; padding-bottom: 16px;">
        <!-- small screen -->
        <div class="d-block d-sm-none col-3">
          <div id="logo">
            <logo/>
          </div>
        </div>
        <div class="d-block d-sm-none col-6 text-center">
            <p style="margin-top: 3px; margin-bottom: 2px; text-transform: uppercase; font-size: 11px">
                {{ selectedEstablishment.name }}
            </p>
            <h3 style="font-size: 20px; font-weight: 400">
              {{ getGroupNameText() }}
            </h3>
        </div>
        <div class="d-block d-sm-none col-3 d-flex justify-content-end align-items-center">
            <div v-on:click="toggleMainNavbar()" class="d-flex justify-content-between align-items-center">
                <icon name="bars" class="me-2"></icon>
                <icon
                    v-if="showMainNavbar === false && (globalChildByIdFilter.length > 0 || globalChildByTextFilter != '')"
                    name="filter-solid"
                    :fontSize="'1.5rem'"
                ></icon>
            </div>
        </div>
        <!-- large screen -->
        <div class="d-none d-sm-block col-sm-2 col-md-1">
            <logo/>
        </div>
        <div class="d-none d-sm-block col-sm-4 col-md-5">
          <router-link to="/select-group" style="color: #666">
            <p style="display: inline-block; margin-top: 2px; margin-bottom: 2px; text-transform: uppercase; font-size: 11px">
                {{ selectedEstablishment.name }}
            </p>
            <br>
            <div style="display: flex; margin-top: 2px; margin-bottom: 6px;">
              <span
                  v-for="(group, index) in selectedGroups"
                  :key="group.id"
              >
                <div
                    v-if="(selectedGroups.length <= 5) || (selectedGroups.length > 5 && index < 4)"
                    class="group-thumbnail"
                    :style="{ backgroundColor: group.color }"
                >
                  <span>{{ group.abbreviation }}</span>
                </div>
              </span>
              <span
                  v-if="selectedGroups.length > 5"
              >
                <div class="group-thumbnail">
                  <span>+</span>
                </div>
              </span>
            </div>
          </router-link>
        </div>
        <div
            v-if="showMainNavbar"
            class="d-md-block col-md-6"
        >
          <div
              class="d-block d-sm-none"
              style="height: 5px;"
          ></div>
          <div id="child-filter-wrapper">
            <child-filter
                :showToggleSideNavbar="true"
                :showToggleGlobalChildByIdFilter="true"
                :showToggleSearch="true"
            />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import ChildFilter from '@/components/Child-Filter'
import Icon from "@/components/Icon.vue";
export default {
  name: 'top-bar',
  components: {
      Icon,
    Logo,
    ChildFilter
  },
  computed: {
    selectedEstablishment () {
      return this.$store.getters.selectedEstablishment
    },
    selectedGroups () {
      return this.$store.getters.selectedGroups
    },
    showSearch () {
      return this.$store.getters.showSearch
    },
    showGlobalChildFilter () {
      return this.$store.getters.showGlobalChildFilter
    },
    showMainNavbar () {
      return this.$store.getters.showMainNavbar
    },
    showSideNavbar () {
      return this.$store.getters.showSideNavbar
    },
    globalChildByIdFilter () {
      return this.$store.getters.globalChildByIdFilter
    },
    globalChildByTextFilter () {
      return this.$store.getters.globalChildByTextFilter
    }
  },
  methods: {
    getGroupNameText () {
      if (this.selectedGroups.length > 1) {
        return 'Combinatiegroep'
      }
      if (this.selectedGroups.length === 1 && this.selectedGroups[0].name) {
        return this.selectedGroups[0].name
      }
      return 'Onbekend'
    },
    toggleMainNavbar () {
      if (this.showMainNavbar === true) {
        this.$store.commit('SET_SHOW_MAIN_NAVBAR', false)
      } else {
        this.$store.commit('SET_SHOW_MAIN_NAVBAR', true)
      }
    }
  }
}
</script>

<style scoped>
  a:hover {
    text-decoration: none;
  }
  *:not(#child-filter-text-query-input) {
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
  }
  #child-filter-wrapper {
    margin-top: 3px;
  }
</style>
